import { get,post,postForm } from '@/Utils/axios'
export default {
    getCustomerList: (params) => get('/nhf-custom/customer/page',params), // 获取客户列表
    addCustomerRow: (params) => post('/nhf-custom/customer/submit',params), // 新增客户数据
    editCustomerRow: (params) => post('/nhf-custom/customer/submit',params), // 编辑客户数据
    deleteCustomerRow: (ids) => postForm(`/nhf-custom/customer/remove?ids=${ids}`), // 删除客户数据
    saveAllCustFactoryStaffRawIdsToCustomer: (params) => post(`/nhf-custom/custfactorystaffraw/saveAllCustFactoryStaffRawIdsToCustomer`,params), // 客户新增完成是否添加全部原料

    
    getCustomerMaterialList: (params) => get('/nhf-custom/custfactorystaffraw/myCustomerRawPage',params), // 获取客户原料列表
    addCustomerMaterialRow: (params) => post('/nhf-custom/custfactorystaffraw/saveFactoryStaffRawIdsToCustomer',params), // 新增客户原料数据
    editCustomerMaterialRow: (params) => post('/nhf-app/factorystaffraw/myRawpage',params), // 编辑客户原料数据
    deleteCustomerMaterialRow: (ids) => postForm(`/nhf-custom/custfactorystaffraw/remove?ids=${ids}`), // 删除客户原料数据
    syncSelectRawsList: (ids) => postForm(`/nhf-custom/custfactorystaffraw/syncSelectRawsList?ids=${ids}`), // 同步选中客户原料数据
    syncCustomerAllRawsList: (params) => post(`/nhf-custom/custfactorystaffraw/syncCustomerAllRawsList`,params), // 同步选中客户原料数据


    selectCustFactoryStaffNutritionRawInfoWithoutSpecialTypePage: '/nhf-custom/custfactorystaffnutritionraw/selectCustFactoryStaffNutritionRawInfoWithoutSpecialTypePage', // 客户管理-养分管列表
};